import { useSelector } from 'react-redux';

import type { PackingSlipTemplate } from '../pages/settings/templates-packing-slips/types';
import Global from '../store/global-selectors';

export const getVisiblePackingSlips = (state: object): PackingSlipTemplate[] =>
  Global.selectSellerPackingSlips(state) as PackingSlipTemplate[];

export const useVisiblePackingSlips = (): PackingSlipTemplate[] => {
  return useSelector(getVisiblePackingSlips);
};
